import React from "react";

import { withRouter } from "react-router-dom";
import CardOnFileService from "../../../services/cardOnFile/CardOnFileService";
import AdminPage from "../common/AdminPage";
import CardOnFile from "@cdkglobal/epay-admin-component/cjs/components/_onePay/middle/cardOnFile/CardOnFile";
import AdminService from "../../../services/admin/AdminService";

const CardOnFilePage = ({ history }) => {
  return (
    <AdminPage showGoBackLink={true} history={history} backPage={""}>
      <CardOnFile
        loadCardOnFiles={CardOnFileService.loadCardOnFiles}
        loadCNumber={AdminService.getCNumber}
        loadActiveDepartments={AdminService.getStores}
        onCreateCardOnFile={CardOnFileService.createCardOnFile}
        onUpdateCardOnFile={CardOnFileService.updateCardOnFile}
        onDeleteCardOnFile={CardOnFileService.deleteCardOnFilebyId}
      />
    </AdminPage>
  );
};

export default withRouter(CardOnFilePage);
